import Vue from 'vue';
import Vuex from 'vuex';

// 使用插件
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    username: ''
  },
  mutations: {
    setUsername(state, { username }) {
      state.username = username;
    }
  }
});

export default store;
